/**
 *  For more information:
 *  https://developers.google.com/admob/unity/reference/namespace/google-mobile-ads/ump/api#privacyoptionsrequirementstatus
 *
 * */
export var PrivacyOptionsRequirementStatus;
(function (PrivacyOptionsRequirementStatus) {
    /**
     * Privacy options entry point is not required.
     */
    PrivacyOptionsRequirementStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
    /**
     * Privacy options entry point is required.
     */
    PrivacyOptionsRequirementStatus["REQUIRED"] = "REQUIRED";
    /**
     * Privacy options requirement status is unknown.
     */
    PrivacyOptionsRequirementStatus["UNKNOWN"] = "UNKNOWN";
})(PrivacyOptionsRequirementStatus || (PrivacyOptionsRequirementStatus = {}));
//# sourceMappingURL=privacy-options-requirement-status.enum.js.map